import { useLocation } from "react-router-dom";
import { SCREENS } from "../routes";
import { matchPath } from "react-router-dom";

export const useCurrentScreen = () => {
  const location = useLocation();

  const matchResult = Object.values(SCREENS)
    .map((screen) => ({
      screen,
      match: matchPath(screen.path, location.pathname),
    }))
    .find((result) => result.match);

  return {
    name: matchResult?.screen.name || "Unknown Screen",
    params: matchResult?.match?.params || {},
  };
};
